<script setup>
   
</script>

<template>
  
<div class="bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-500">

  <!-- HEADER / NAVIGATION Menui - Digitaliza tu menú -->
  <header class="w-full px-6 py-4 flex justify-between items-center border-b border-gray-200 dark:border-gray-700">
    <div class="flex items-center space-x-2">
      <div class="text-2xl font-bold text-[#ff642e]">Menui</div>
    </div>
    <nav class="hidden md:flex space-x-6 font-medium">
      <a href="#features-business" class="hover:text-[#ff642e]">Para Negocios</a>
      <a href="#features-users" class="hover:text-[#ff642e]">Para Usuarios</a>
      <a href="#testimonials" class="hover:text-[#ff642e]">Testimonios</a>
      <a href="#contact" class="hover:text-[#ff642e]">Contacto</a>
    </nav>
    <div class="flex items-center space-x-4">
      <a href="#signup" class="bg-[#ff642e] text-white px-4 py-2 rounded hover:bg-orange-500 transition">Regístrate gratis</a>
    </div>
  </header>

  <!-- HERO SECTION -->
  <section class="px-6 py-20 flex flex-col-reverse md:flex-row items-center justify-between max-w-7xl mx-auto">
    <div class="md:w-1/2 space-y-6">
      <h1 class="text-4xl md:text-5xl font-bold leading-tight">Digitaliza tu menú. Conecta con tus clientes. Crece tu negocio.</h1>
      <p class="text-gray-700 dark:text-gray-300 text-lg">Menui simplifica la gestión de tu menú y mejora la experiencia de tus clientes. Ideal para restaurantes y comensales.</p>
      <a href="#signup" class="inline-block bg-[#ff642e] text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-orange-500 transition">Prueba gratis para tu restaurante</a>
    </div>
    <div class="md:w-1/2 flex justify-center mb-10 md:mb-0">
      <!-- Placeholder para ilustración/animación -->
      <div class="w-64 h-128 bg-gray-200 dark:bg-gray-700 rounded-xl flex items-center justify-center">
        <span class="text-gray-400 dark:text-gray-400">[Imagen PWA]</span>
      </div>
    </div>
  </section>

  <!-- FEATURES BUSINESS -->
  <section id="features-business" class="px-6 py-20 bg-gray-50 dark:bg-gray-800">
    <div class="max-w-6xl mx-auto text-center mb-12">
      <h2 class="text-3xl font-bold">Beneficios para tu restaurante</h2>
      <p class="text-gray-600 dark:text-gray-300 mt-2">Descubre cómo Menui transforma la experiencia de tu negocio.</p>
    </div>
    <div class="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto text-center">
      <div class="p-6 bg-white dark:bg-gray-900 rounded-lg shadow hover:shadow-lg transition">
        <div class="text-4xl mb-4">📝</div>
        <h3 class="font-semibold text-xl mb-2">Gestión Sencilla</h3>
        <p class="text-gray-600 dark:text-gray-300">Crea y actualiza tu menú en minutos.</p>
      </div>
      <div class="p-6 bg-white dark:bg-gray-900 rounded-lg shadow hover:shadow-lg transition">
        <div class="text-4xl mb-4">🚀</div>
        <h3 class="font-semibold text-xl mb-2">Impacto Inmediato</h3>
        <p class="text-gray-600 dark:text-gray-300">Llega a nuevos clientes y aumenta tus pedidos.</p>
      </div>
      <div class="p-6 bg-white dark:bg-gray-900 rounded-lg shadow hover:shadow-lg transition">
        <div class="text-4xl mb-4">📊</div>
        <h3 class="font-semibold text-xl mb-2">Análisis y Crecimiento</h3>
        <p class="text-gray-600 dark:text-gray-300">Obtén datos sobre lo que más piden tus clientes.</p>
      </div>
    </div>
  </section>

  <!-- FEATURES USERS -->
  <section id="features-users" class="px-6 py-20">
    <div class="max-w-6xl mx-auto text-center mb-12">
      <h2 class="text-3xl font-bold">Beneficios para tus clientes</h2>
      <p class="text-gray-600 dark:text-gray-300 mt-2">La experiencia de comer fuera nunca fue tan fácil.</p>
    </div>
    <div class="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto text-center">
      <div class="p-6 bg-gray-50 dark:bg-gray-800 rounded-lg shadow hover:shadow-lg transition">
        <div class="text-4xl mb-4">📍</div>
        <h3 class="font-semibold text-xl mb-2">Menús Cerca de Ti</h3>
        <p class="text-gray-600 dark:text-gray-300">Descubre restaurantes a tu alrededor con un toque.</p>
      </div>
      <div class="p-6 bg-gray-50 dark:bg-gray-800 rounded-lg shadow hover:shadow-lg transition">
        <div class="text-4xl mb-4">🎁</div>
        <h3 class="font-semibold text-xl mb-2">Promociones Exclusivas</h3>
        <p class="text-gray-600 dark:text-gray-300">Encuentra descuentos y ofertas especiales.</p>
      </div>
      <div class="p-6 bg-gray-50 dark:bg-gray-800 rounded-lg shadow hover:shadow-lg transition">
        <div class="text-4xl mb-4">📲</div>
        <h3 class="font-semibold text-xl mb-2">Pedidos Simplificados</h3>
        <p class="text-gray-600 dark:text-gray-300">Genera un QR para tu orden y sorprende a tu mesero.</p>
      </div>
    </div>
  </section>

  <!-- TESTIMONIALS -->
  <section id="testimonials" class="px-6 py-20 bg-gray-50 dark:bg-gray-900">
    <div class="max-w-6xl mx-auto text-center mb-12">
      <h2 class="text-3xl font-bold">Testimonios</h2>
      <p class="text-gray-600 dark:text-gray-300 mt-2">Historias de éxito de restaurantes y usuarios.</p>
    </div>
    <div class="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">
      <div class="p-6 bg-white dark:bg-gray-800 rounded-lg shadow">
        <p class="italic">"Menui nos permitió actualizar nuestro menú en minutos y aumentar nuestros pedidos diarios. ¡Totalmente recomendado!"</p>
        <p class="mt-4 font-semibold">- Juan Pérez, Restaurante La Sabrosura</p>
      </div>
      <div class="p-6 bg-white dark:bg-gray-800 rounded-lg shadow">
        <p class="italic">"Ahora puedo descubrir menús cerca de mí y hacer pedidos sin complicaciones. ¡Me encanta Menui!"</p>
        <p class="mt-4 font-semibold">- Ana López, Usuaria</p>
      </div>
    </div>
  </section>

  <!-- FINAL CTA -->
  <section class="px-6 py-20 text-center bg-[#ff642e] text-white">
    <h2 class="text-4xl md:text-5xl font-bold mb-6">Únete a la revolución digital de los menús</h2>
    <a href="#signup" class="bg-white text-[#ff642e] px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition">Regístrate ahora</a>
  </section>

  <!-- FOOTER -->
  <footer id="contact" class="px-6 py-10 bg-gray-100 dark:bg-gray-900 text-gray-700 dark:text-gray-300">
    <div class="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
      <p>&copy; 2025 Menui.com.mx</p>
      <div class="flex space-x-6">
        <a href="#" class="hover:text-[#ff642e]">Política de Privacidad</a>
        <a href="#" class="hover:text-[#ff642e]">Términos de Servicio</a>
        <a href="#" class="hover:text-[#ff642e]">Contacto</a>
      </div>
    </div>
  </footer>
</div>

</template>


